import NavBar from "./Components/NavBar";
import Hero from "./Components/Hero";
import Dropdown from "./Components/Dropdown";
import Stats from "./Components/Stats";
import Partners from "./Components/Partners";
import Why from "./Components/Why";
import RealTimeStats from "./Components/RealTimeStats";
import Offers from "./Components/Offers";
import Languages from "./Components/Languages";
import Class from "./Components/Class";
import Mentor from "./Components/Mentor";
import Testimonials from "./Components/Testimonials";
import Form from "./Components/Form";
import Feature from "./Components/Feature";
import Footer from "./Components/Footer";
import Blog from "./Components/Blog";






function App() {
  return (
    <div>
      
      <NavBar />
      <Hero />
      <Stats />
      <Partners />
      <Why />
      <RealTimeStats />
      <Offers />
      <Languages />
      <Class />
      <Mentor />     
      <Feature />
      <Testimonials />
      <Blog />
      
      <Form />
      <Footer />
    </div>
  );
}

export default App;
